import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { File } from './files/File.js';
export class Policy extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = '';
        /**
         * Set either file or url for the policy. If both are set, the url has priority
         */
        this.file = null;
        this.url = null;
    }
    get calculatedUrl() {
        var _a, _b;
        if (this.url !== null) {
            return this.url;
        }
        return (_b = (_a = this.file) === null || _a === void 0 ? void 0 : _a.getPublicPath()) !== null && _b !== void 0 ? _b : '';
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Policy.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Policy.prototype, "name", void 0);
__decorate([
    field({ decoder: File, nullable: true, version: 25 })
], Policy.prototype, "file", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 25 })
], Policy.prototype, "url", void 0);
//# sourceMappingURL=Policy.js.map